export const navUrlKeyMap: { [key: string]: string } = {
  "/": "1",
  "/record": "11",
  "/todoGroupList": "21",
  "/todoList": "21",
  "/oj": "22",
  "/funds": "31",
  "/cipher": "41",
  "/tool": "51",
  "/login": "91",
}

export const navKeyUrlMap: { [key: string]: string } = {
  "1": "/",
  "11": "/record",
  "21": "/todoGroupList",
  "22": "/oj",
  "31": "/funds",
  "41": "/cipher",
  "51": "/tool",
  "91": "/login",
}
